import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";

import {
    imprestApplications,
  leaveApplications,
  leaveApplicationsByUser,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import { LeaveApplicationsColumns, imprestApplicationsColumns } from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import LeaveApplicationForm from "./form";

const base_url = HRService.uri;
const actions = {
 // entity: " Imprest Approvals",

  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: false,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: false,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  markTask: {
    key: "MARK_TASK_DONE",
    button_name: "Mark Task Done",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  approve: {
    key: "APPROVE_LEAVE",
    button_name: "Approve Imprest Requisition",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
  decline: {
    key: "REJECT_LEAVE",
    button_name: "Reject Imprest Requisition",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
    },
    dataObject: {
        inputObjectName: "approveDeclineImprestApplication",
        inputSubObjectName: "applicationsApprovals",
        inputFields: [
            "applicationId",
            "userId",
            "comments",
        ]

  },

  actionName: " Imprest Requisition ",
  showStatus: true,
};
function ImprestApprovalsTable() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Imprest Approvals"
          subtitle="View all imprest approvals, approve or decline"
          columns={imprestApplicationsColumns}
          FormComponent={LeaveApplicationForm}
          query={imprestApplications}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default ImprestApprovalsTable;
